import React from 'react'
import Config from '../../../../config/'
import { object } from 'prop-types'
import LocProductList from './locProductList.jsx'

class AirportParkingReviews extends React.Component {

  checkReviewExist( data ){
    return Object.keys(data).find(key => {
      const item = data[key]
      if (!item || item == "null") return
      const productName = item.productName || item.prodlib.name
      return item.score && item.score['reviewed'] && productName.toLowerCase().indexOf('mystery')
    })
  }

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'parking'
      case 'HCP':
        return 'hotels'
      case 'HO':
        return 'hotels'
      case 'LO':
        return 'lounges'
    }

    return ''
  }

  getConfigPath ( param ) {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return param == 'locations' ? Config.locations.carParking : 'parkingLocations'
      case 'HCP':
        return param == 'locations' ? Config.locations.hotels : 'hotelLocations'
      case 'HO':
        return param == 'locations' ? Config.locations.hotels : 'hotelLocations'
      case 'LO':
        return param == 'locations' ? Config.locations.loungeCodes : 'loungesLocations'
    }

    return ''
  }

  getLocationReviews(){
    try{
      const locations = this.getConfigPath( 'locations' )
      const productMeta = this.getConfigPath( 'meta' )
      const product = this.getFeedPath()
        return Object.keys(locations).map((key, i) => {
          let data = require('../../../../../config/exports/buildTimeOnly/' + productMeta + '/' + key + '.json')
          if (!data || data == "null") return
          //check for atleast one reviewed product
          if (!this.checkReviewExist( data )) return
          const targetKey = "#" + key
          return (
            <div className="panel panel-default" key={key + '_' + i}>
              <div className="collapse-heading center-block panel-heading collapsed" data-target={targetKey} data-toggle="collapse" aria-controls={locations[key]} aria-expanded="false">
                <h3>
                    <i className='fa fa-lg fa-angle-down collapse-icon text-faded'></i>
                    {locations[key]} airport {product} reviews
                </h3>
              </div>
              {<LocProductList id={key} data={data} /> }
            </div>
          )
        })
    }
    catch(e){}
  }

  render () {
    return (
      <div>
        {this.getLocationReviews()}
      </div>
    )
  }
}

AirportParkingReviews.propTypes = {
  pageData: object.isRequired
}

export default AirportParkingReviews



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/airportParkingReviews.jsx